const getMaxWidth = (dpi, width) => {
  return 4000 * dpi / 25.4 * width
}

export default getMaxWidth



// WEBPACK FOOTER //
// ./src/utils/getMaxWidth.js